import React, { Component } from "react"
import styled from "styled-components"
import FormField from "../FormField"
import { InputNumber, Select } from "formik-antd"
import { PlusCircleOutlined } from '@ant-design/icons';
import { Row, Col, Button, Divider } from "antd"
import SearchSelect from "src/shared/SearchSelect"
import { locations } from "src/constants/account"
import { FieldArray } from "formik"

const RemoveButton = styled(Button)`
  &&& {
    margin-top: 35px;
  }
`

export default class LocationsBreakdown extends Component {
  render() {
    const { countryBreakdown } = this.props
    const comparisonOptions = [
      {
        label: "Less than (<)",
        value: "lt"
      },
      {
        label: "Greater than (>)",
        value: "gt"
      }
    ]

    return (
      <FieldArray
        name={`countryBreakdown`}
      >
        {({ insert, remove, push }) => (
          <div>
            <Divider orientation="left">Country Breakdown</Divider>
            {typeof countryBreakdown !== "undefined" &&
              countryBreakdown.length > 0 &&
              countryBreakdown.map((data, index) => {
                return (
                  <Row gutter={8} key={index}>
                    <Col span={8}>
                      <FormField name={`countryBreakdown[${index}].key`} label="Locations">
                        <SearchSelect size="large" placeholder="Select..." data={locations} local />
                      </FormField>
                    </Col>

                    <Col span={6}>
                      <FormField name={`countryBreakdown[${index}].comparison`} label="comparison">
                        <Select size="large" placeholder="comparison" options={comparisonOptions}>
                        </Select>
                      </FormField>
                    </Col>

                    <Col span={6}>
                      <FormField name={`countryBreakdown[${index}].value`} label="Percentage">
                        <InputNumber size="large" min={0} max={100} />
                      </FormField>
                    </Col>
                    <Col span={4}>
                      <RemoveButton
                        onClick={() => remove(index)}
                        type="primary"
                        shape="circle"
                        icon="close-circle"
                      />
                    </Col>
                  </Row>
                )
              })}
            <Row gutter={8}>
              <Col span={8}></Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
              <Col span={4}>
                <Button
                  onClick={() => push({ key: "", comparison: "", value: "" })}
                  type="primary"
                  shape="circle"
                  icon={<PlusCircleOutlined />}
                />
              </Col>
            </Row>
          </div>
        )}
      </FieldArray>
    );
  }
}
